import { useTranslation } from "react-i18next";
import Api from "../../../../constants/Api";
import MenuConfig from "../../../../constants/MenuConfig";
import ListPage from "../../../layouts/page/ListPage";
import { PerformancePlanColumns } from "./Columns";

const PerformancePlanList = () => {

    const { t } = useTranslation();

    return (
        <ListPage
            showPageTitle="true"
            activeMenu={t('performance.plans')}
            motherMenu={t('performance.label')}
            path={Api.performance.plan}
            route={MenuConfig.performance.plan.route}
            columns={PerformancePlanColumns}
        />
    );
}

export default PerformancePlanList;
